import type { ComponentPropsWithRef } from 'react';

import { buttonVariants } from '@/shared-ui/atoms/button';
import { cn } from '@/lib/utils';

import { AppleAppStoreSvg } from './apple-app-store';
import { GooglePlaySvg } from './google-play';

export interface AppStoreBadgeProps extends ComponentPropsWithRef<'a'> {
    platform: 'apple' | 'google';
    variant?: 'primary' | 'secondary';
}

export const AppStoreBadge = ({ platform, variant = 'primary', className, ref, ...props }: AppStoreBadgeProps) => (
    <a
        data-slot="app-store-badge"
        data-platform={platform}
        data-variant={variant}
        className={cn(buttonVariants({ variant }), 'h-auto py-3 px-4', className)}
        ref={ref}
        {...props}>
        {platform === 'apple' ? (
            <AppleAppStoreSvg aria-label="Download on the App Store" className="size-auto" />
        ) : (
            <GooglePlaySvg aria-label="Get it on Google Play" className="size-auto" />
        )}
    </a>
);
